module.exports = __webpack_public_path__ + "img/feature_tt_bg.96ae436b.png";